<template>
	<div class="flyt-booking">
		<div class="flyt-booking__container container">
			<BookingStepper />
		</div>
		<BookingMap />
	</div>
</template>

<script>
import Vue from 'vue'
import BookingStepper from "./booking/form/BookingStepper"
import BookingMap from "./booking/map/BookingMap"
import throttle from "lodash.throttle"
import { mapActions, mapGetters } from "vuex"

export default {
	data() {
		return {
			biggerThanMobileWidth: 752,
		}
	},

	name: "FlytBooking",

	components: { BookingStepper, BookingMap },

	computed: {
		...mapGetters("auth", ["isLoggedIn"]),
	},

	methods: {
		...mapActions("browser", ["updateIsMobile"]),
		...mapActions("auth", ["login", "logout", "getUser"]),
		...mapActions("map", ["storeMapPadding"]),

		/**
		 * Add globally available references to dom
		 * elements that are outside Vue's scope.
		 */
		setGlobalNodes() {
			Vue.prototype.$navbar = document.querySelector(".navbar")
		},

		// Set a custom css variable that is equal to 1/100th of the viewport height.
		setVhCustomProperty() {
			let vh = window.innerHeight * 0.01
			document.documentElement.style.setProperty("--vh", `${vh}px`)
		},

		// Returns width of the booking form
		getFormWidth() {
			const bookingForm = document.querySelector(".booking-stepper")
			return bookingForm.offsetWidth
		},

		// Calculate and store padding for the map based on the container and booking form dimensions
		updateMapPadding() {
			const inset = 20
			let container = document.querySelector(".flyt-booking__container")
			let containerStyles = window.getComputedStyle(container)
			let leftPadding = parseInt(containerStyles.getPropertyValue("padding-left"), 10)
			let rightPadding = parseInt(containerStyles.getPropertyValue("padding-right"), 10)
			let formWidth = this.getFormWidth()
			let padding = {
				top: 80,
				left: container.offsetLeft + leftPadding + inset,
				right: container.offsetLeft + rightPadding + formWidth + inset,
				bottom: inset,
			}
			this.storeMapPadding(padding)
		},

		// Returns whether the current window size is bigger than the predefined limit declared in the data.
		isBiggerThanMobile() {
			this.updateIsMobile(window.innerWidth < this.biggerThanMobileWidth)
		},

		// All functions that should be called on resize.
		resizeFunctions() {
			this.setVhCustomProperty()
			this.isBiggerThanMobile()
			this.updateMapPadding()
		},
	},

	mounted() {
		let vm = this
		window.addEventListener(
			"resize",
			throttle(() => vm.resizeFunctions(), 100, { leading: true })
		)
		// Call all resize functions on load
		this.resizeFunctions()
		// Fetch user
		this.getUser()
		// Add node references directly on the vue object
		this.setGlobalNodes()
	},
}
</script>

<style lang="scss" scoped>
.flyt-booking {
	height: 100%;
	position: relative;
}

.flyt-booking__container {
	padding: 0;
	@media screen and (min-width: map-get($widths, 'tablet-medium')) {
		padding: $navbar-height var(--container-padding) 0;
	}
}
</style>
